<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula - Polivalência</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <!-- Seção: Informações Básicas -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Informações da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula:</label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Seção: Horários -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Seleção de Horários
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-alert v-show="messageAlert" dense outlined type="warning" class="mb-4">
                    {{ messageAlert }}
                  </v-alert>

                  <div
                    v-for="item in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="item.id"
                    class="mb-4"
                  >
                    <e-label class="font-weight-medium">{{ getNomeDisciplina(item.id) }}</e-label>
                    <e-autocomplete
                      :items="horariosFiltrados"
                      multiple
                      outlined
                      chips
                      small-chips
                      label="Selecione os horários"
                      item-text="descricao"
                      item-value="id"
                      v-model="horarios_selecionados_extras[item.id]"
                      return-object
                      dense
                      @change="verifyHorariosSelectExtra($event, item.id)"
                    />
                  </div>
                </v-card-text>
              </v-card>

              <!-- Seção: Conteúdo -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Conteúdo Programado
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <div
                    v-for="(item, index) in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="index"
                    class="mb-4"
                  >
                    <v-subheader class="pl-0 font-weight-bold">{{
                      getNomeDisciplina(item["id"])
                    }}</v-subheader>
                    <v-card flat class="pa-3 grey lighten-4 rounded">
                      {{ JSON.parse(aulaDuplicada.conteudo_polivalencia)[index] }}
                    </v-card>
                    <v-divider
                      v-if="index < JSON.parse(aulaDuplicada.horarios_extras).length - 1"
                      class="my-3"
                    ></v-divider>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Seção: Metodologia -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Metodologia
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <p class="text-body-1">{{ aulaDuplicada.metodologia }}</p>
                </v-card-text>
              </v-card>

              <!-- Ações -->
              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  Cancelar
                </v-btn>
                <v-btn color="primary" :disabled="desabilitarSalvamento" type="submit" depressed>
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
    tipoAula: {
      type: String,
      require: false,
    },
  },
  mounted() {
    this.array_horarios_extras = JSON.parse(this.aulaDuplicada.horarios_extras).map((item) => ({
      id: item.id,
      array: [],
    }));
  },
  data() {
    return {
      array_horarios_extras: [],
      editarHorario: false,
      horarios_selecionados_extras: [],
      messageAlert: null,
      desabilitarSalvamento: false,
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosSabado: [],
      horariosFiltrados: [],
      objectModal: {
        title: "Duplicar aula - Polivalência",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
    };
  },
  watch: {
    data(val) {
      const count = 0;
      JSON.parse(this.aulaDuplicada.horarios_extras).forEach((element) => {
        element.array.forEach((horario) => {
          this.pesquisaAulas(horario, element.id, val);
        });
      });
    },
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      // Chama o filtro de horários pelo dia da semana
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
    },
  },
  methods: {
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          // Sábado: pega todos os horários da gestão
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          // Outros dias: filtra os horários relacionados ao dia específico
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },

    getHorariosDaAula(aula) {
      try {
        if (!aula?.horarios_extras) return [];
        return JSON.parse(aula.horarios_extras);
      } catch (error) {
        return [];
      }
    },

    getArrayHorarios(idsHorarios) {
      if (!idsHorarios || !this.horariosFiltrados) return [];
      return idsHorarios
        .map((id) => this.horariosFiltrados.find((horario) => horario.id === id))
        .filter(Boolean);
    },

    valoresComuns(array1, array2) {
      return array1.filter((valor) => array2.includes(valor));
    },
    verifyHorariosSelectExtra(items, disciplinaId) {
      try {
        // Inicializa o array se necessário
        if (!this.array_horarios_extras.some((item) => item.id === disciplinaId)) {
          this.array_horarios_extras.push({
            id: disciplinaId,
            array: [],
          });
        }

        // Atualiza os horários selecionados para esta disciplina
        const disciplina = this.array_horarios_extras.find((item) => item.id === disciplinaId);
        disciplina.array = items.map((item) => item.id);

        // Verifica conflitos com outras disciplinas
        this.verificarConflitosHorarios(disciplinaId);

        // Verifica disponibilidade na data selecionada
        if (this.data) {
          items.forEach((item) => {
            this.pesquisaAulas(item.id, disciplinaId);
          });
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    verificarConflitosHorarios(disciplinaId) {
      const currentDisciplina = this.array_horarios_extras.find((item) => item.id === disciplinaId);
      if (!currentDisciplina) return;

      const outrosHorarios = this.array_horarios_extras
        .filter((item) => item.id !== disciplinaId)
        .flatMap((item) => item.array);

      const conflitos = currentDisciplina.array.filter((horarioId) =>
        outrosHorarios.includes(horarioId)
      );

      if (conflitos.length > 0) {
        const horarioConflitante = this.getArrayHorarios(conflitos)[0];
        this.$toast.danger(
          `Outra disciplina está usando o horário ${horarioConflitante.descricao}!`
        );

        // Remove os horários conflitantes
        this.horarios_selecionados_extras[disciplinaId] = this.horarios_selecionados_extras[
          disciplinaId
        ].filter((item) => !conflitos.includes(item.id));

        currentDisciplina.array = currentDisciplina.array.filter((id) => !conflitos.includes(id));
      }
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0].descricao;
      }
    },
    getNomeDisciplina(id) {
      const dis = this.gestaoDeAulas.disciplinas_com_descricao.filter((obj) => obj.id === id);
      return dis[0].descricao;
    },
    async pesquisaAulas(horarioId, disciplinaId, data) {
      const data_aula = this.data.split("/").reverse().join("-");
      // /* eslint-disable */
      const { aula_id } = this.$route.params;
      const turma_id = this.aulaDuplicada.turma_id;
      if (!data_aula || !horarioId || !this.aulaDuplicada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
        data_aula,
        horarioId,
        turma_id,
        0
      );

      this.messageAlert = null;
      this.desabilitarSalvamento = false;

      if (response.data === 1) {
        this.aulasEmConflitos = true;
        this.messageAlert =
          "Já existe aula registrada nessa data com esses mesmos horários, selecione uma outra data!";
        this.desabilitarSalvamento = true;
      }
    },
    enableSubmit() {
      // Verifica se todos os horários estão preenchidos para cada disciplina
      const horariosExtras = JSON.parse(this.aulaDuplicada.horarios_extras || "[]");

      const todosPreenchidos = horariosExtras.every(
        (item) =>
          Array.isArray(this.horarios_selecionados_extras[item.id]) &&
          this.horarios_selecionados_extras[item.id].length > 0
      );
      if (this.data && todosPreenchidos) {
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      } else {
        this.$toast.danger("Preencha todos os horários de todas as disciplinas.");
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        // Atualiza os horários extras da aula duplicada com os horários selecionados pelo usuário
        this.aulaDuplicada.horarios_extras = JSON.stringify(
          this.array_horarios_extras.map((item) => ({
            id: item.id,
            array: item.array, // array de ids dos horários selecionados
          }))
        );

        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;

        const response =
          this.tipoAula === "complementar"
            ? await this.$services.aulasComplementaresService.criar(this.aulaDuplicada)
            : await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
</style>
